import { getVerticalizedTopBannerText } from "@faire/retailer-visitor-shared/components/Notifications/Components/__internal__/getVerticalizedTopBannerText";
import { useFirstOrderIncentiveFormattedData } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveFormattedData";
import { useFirstOrderIncentiveStore } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveStore";

export const useVerticalizedFOITopBannerText = () => {
  const { formattedIncentivePercent } = useFirstOrderIncentiveFormattedData();
  const { isMaximalistFoi, isFirstOrderForFaireDirectIncentive } =
    useFirstOrderIncentiveStore();

  return getVerticalizedTopBannerText({
    formattedIncentivePercentNumber: formattedIncentivePercent,
    isMaximalistFoi,
    isFoiForFD: isFirstOrderForFaireDirectIncentive,
  });
};
